export default {"src":"/_next/static/media/super-sitters-pets.9162c52d.svg","height":58,"width":49,"blurWidth":0,"blurHeight":0};